module.exports = __webpack_public_path__ + "img/tit-news.b286ae19.png";